import { useState } from "react";

import ForumPost from "@/components/content-types/ForumPost/ForumPost";
import URLS from "@/constants/urls";
import { ForumFlipWrapper } from "@/styles/global.styled";
import { ForumPost as ForumPostType } from "@/types/api/forum.types";

interface ForumPostWrapperProps {
  item: ForumPostType;
  inMasonryGrid?: boolean;
  isForAdults?: boolean;
}

const ForumPostWrapper = ({
  item,
  inMasonryGrid,
  isForAdults = false,
}: ForumPostWrapperProps) => {
  const [likesCount, setLikesCount] = useState(item.likes_count ?? 0);

  return (
    <ForumFlipWrapper
      item
      xs={12}
      md={inMasonryGrid ? 12 : 4}
      className={`forum-card ${inMasonryGrid ? "h-full" : "h-fit"}`}
    >
      <div className={`forum-content ${inMasonryGrid ? "auto-cols-fr" : ""}`}>
        <div className="front">
          <ForumPost
            id={item.id}
            truncateContent
            gender={item.user_gender}
            age={item.user_age}
            name={item.user_name}
            postDate={new Date(item.date_created)}
            tags={item.categories?.map((cat) => cat.name) ?? []}
            tagsInverse={item.tags?.map((tags) => tags.name) ?? []}
            title={item.title ?? "Titel moet in CMS worden ingevoerd"}
            comments={item.comments.length}
            content={item.content}
            className="forum-post forum-list"
            likesCount={likesCount}
            commentsCount={item?.comments?.length || 0}
            setLikesCount={setLikesCount}
          />
        </div>
        <div className="back z-10">
          <ForumPost
            id={item.id}
            truncateContent
            gender={item.user_gender}
            age={item.user_age}
            name={item.user_name}
            postDate={new Date(item.date_created)}
            button={true}
            tagsBack={item.categories?.map((cat) => cat.name) ?? []}
            tagsInverseBack={item.tags?.map((tags) => tags.name) ?? []}
            title={item.title ?? "Titel moet in CMS worden ingevoerd"}
            comments={item.comments.length}
            content={item.content}
            className="forum-post forum-list"
            buttonUrl={`${isForAdults ? URLS.PAGES.FORUM_PARENTS : URLS.PAGES.FORUM_CHILDREN}/${item?.slug}`}
            likesCount={likesCount}
            commentsCount={item?.comments?.length || 0}
            setLikesCount={setLikesCount}
            isBackSide
          />
        </div>
      </div>
    </ForumFlipWrapper>
  );
};

export default ForumPostWrapper;
